import React from 'react';
import { Typography } from '@mui/material';
import VariableTextField from '../../VariableTextField';
import { FlowComponent } from '../../../../flow-core/FlowComponent';
import { TextSubheadingCore } from '../../../../flow-core/components/TextSubheadingCore';

export const TextSubheadingComponent = new FlowComponent({
  ...TextSubheadingCore,
  renderPreview(properties) {
    return (
      // Match WhatsApp's TextSubheading: ~20px bold, MUI h5 (24px) rendered identical
      // to TextHeading (also 24px after its WhatsApp-size fix), losing the hierarchy.
      <Typography
        component="h2"
        gutterBottom
        sx={{ fontSize: '1.25rem', fontWeight: 700, lineHeight: 1.3 }}
      >
        {properties.text || 'Subheading Text'}
      </Typography>
    );
  },
  renderPropertyEditor(properties, onChange, context) {
    return (
      <VariableTextField
        fullWidth
        label="Text"
        value={properties.text || ''}
        onChange={(e) => onChange('text', e.target.value)}
        required
        inputProps={{ maxLength: 80 }}
        helperText={`${(properties.text || '').length}/80 characters, use {x} to insert field references`}
        size="small"
        screens={context?.screens}
        currentScreenId={context?.currentScreenId}
      />
    );
  },
});
